import { render, staticRenderFns } from "./SupervisorRfqGroupMaintain.vue?vue&type=template&id=b86e89f8&scoped=true"
import script from "./SupervisorRfqGroupMaintain.vue?vue&type=script&lang=js"
export * from "./SupervisorRfqGroupMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86e89f8",
  null
  
)

export default component.exports